export const HOME_ADDR = "/";
export const LOGIN = "/login";
export const SIGNIN = "/signin";
export const SIGNUP = "/signup";
export const HISTORY = "/history";